import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useI18n, LanguageSwitcher } from "@/i18n";
import { LEGAL_NOTICE, PRIVACY } from "@/lib/legalContent";

export default function LegalPage({ doc }) {
  const navigate = useNavigate();
  const { t, lang } = useI18n();
  const data = (doc === "privacy" ? PRIVACY : LEGAL_NOTICE)[lang] || (doc === "privacy" ? PRIVACY : LEGAL_NOTICE).fr;

  return (
    <div className="min-h-screen bg-[#fafafa]" data-testid={`legal-page-${doc}`}>
      <header className="sticky top-0 z-40 bg-[#fafafa]/90 backdrop-blur-md border-b border-[#e8ebf2]">
        <div className="max-w-4xl mx-auto px-5 h-20 flex items-center justify-between gap-4">
          <button onClick={() => navigate("/")} data-testid="legal-logo-home">
            <Logo imgClassName="h-11 sm:h-12" />
          </button>
          <LanguageSwitcher variant="light" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 py-12">
        <button
          onClick={() => navigate("/")}
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-[#4b5b7c] font-semibold hover:text-[#1a2d56] mb-6"
        >
          <ArrowLeft size={18} /> {t("legal_back")}
        </button>

        <h1 className="font-head text-3xl sm:text-4xl font-extrabold text-[#1a2d56]">{data.title}</h1>
        <p className="text-sm text-[#9aa6c0] mt-2">{data.updated}</p>

        <div className="mt-8 space-y-8">
          {data.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-head text-lg font-bold text-[#1a2d56] mb-2">{s.h}</h2>
              <div className="space-y-2">
                {s.p.map((para, i) =>
                  para.startsWith("• ") ? (
                    <p key={`${s.h}-${i}`} className="text-[#4b5b7c] leading-relaxed pl-4 relative">
                      <span className="absolute left-0 text-[#d7de3b]">•</span>
                      {para.slice(2)}
                    </p>
                  ) : (
                    <p key={`${s.h}-${i}`} className="text-[#4b5b7c] leading-relaxed">{para}</p>
                  )
                )}
              </div>
            </section>
          ))}
        </div>
      </main>

      <footer className="bg-white border-t border-[#e8ebf2] py-10">
        <div className="max-w-4xl mx-auto px-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Logo imgClassName="h-10" />
          <p className="text-sm text-[#4b5b7c] text-center">{t("footer_text")}</p>
        </div>
      </footer>
    </div>
  );
}
